import type { Order } from '../types/orders';

/**
 * Cómo se nombra una orden en pantalla: "#123", o el folio provisional ("SIN RED 7") si se
 * tomó sin conexión y el servidor todavía no le asigna su consecutivo (hasta entonces es 0).
 */
export const formatOrderNumber = (order: Pick<Order, 'orderNumber' | 'offlineFolioLabel'>): string =>
  order.offlineFolioLabel ?? `#${order.orderNumber}`;
